import { ServiceIdForMember, SEOSegmentationSearchingFor } from '@/__generated__/globalTypes';

export const shouldShowUserFilters = (
  searchingFor: keyof typeof SEOSegmentationSearchingFor | undefined | null,
  serviceIdForMember: keyof typeof ServiceIdForMember
) => {
  const showPetCareUserFilters =
    searchingFor === SEOSegmentationSearchingFor.PROVIDER &&
    serviceIdForMember === ServiceIdForMember.PET_CARE;

  const showSeniorCareUserFilters =
    searchingFor === SEOSegmentationSearchingFor.PROVIDER &&
    serviceIdForMember === ServiceIdForMember.SENIOR_CARE;

  const showChildCareUserFilters =
    (searchingFor === SEOSegmentationSearchingFor.PROVIDER ||
      searchingFor === SEOSegmentationSearchingFor.ALL_PROVIDER) &&
    (serviceIdForMember === ServiceIdForMember.CHILD_CARE ||
      serviceIdForMember === ServiceIdForMember.BABYSITTER ||
      serviceIdForMember === ServiceIdForMember.NANNY);

  const showHomeCareUserFilters =
    (searchingFor === SEOSegmentationSearchingFor.PROVIDER ||
      searchingFor === SEOSegmentationSearchingFor.ALL_PROVIDER) &&
    serviceIdForMember === ServiceIdForMember.HOUSEKEEPING;

  return (
    showPetCareUserFilters ||
    showSeniorCareUserFilters ||
    showChildCareUserFilters ||
    showHomeCareUserFilters
  );
};
